import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app";
import { PRODUCT_BRANDS, applyProductBranding, detectProduct } from "./app/product";

applyProductBranding(document, PRODUCT_BRANDS[detectProduct()]);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
